/* TODO: t() */
import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

import Hoverable from '../Hoverable';
import { themeColors } from '../Constants';

type Props = {
  children: React.ReactNode;
  style?: StyleSet;
  onPress?: () => void;
  // Style passed from rowRenderer when used together with List from react-virtualized
  virtualizedStyle?: StyleSet;
};

function DataTableRow({ children, style, onPress, virtualizedStyle }: Props) {
  return (
    <Hoverable
      render={(isHovered, eventHandlers) => (
        <TouchableOpacity
          activeOpacity={0.6}
          style={[
            virtualizedStyle,
            styles.root,
            isHovered && styles.hoveredRoot,
            style,
          ]}
          onPress={onPress}
          disabled={!onPress}
        >
          <View {...eventHandlers} style={styles.content}>
            {children}
          </View>
        </TouchableOpacity>
      )}
    />
  );
}

let marginBottom = 10;
let height = 42;

DataTableRow.totalHeight = height + marginBottom;

let styles = StyleSheet.create({
  root: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 20,
    backgroundColor: themeColors.white,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: themeColors.borderGrey,
    borderRadius: 5,
    marginBottom,
    height,
  },
  hoveredRoot: {
    backgroundColor: themeColors.withOpacity.blue8,
    borderColor: themeColors.withOpacity.blue50,
    zIndex: 2,
  },
  content: {
    flex: 1,
    flexDirection: 'row',
  },
});

export default DataTableRow;
